export const SKIP_AUTH_INTERCEPTOR_HEADER = {name: 'X-Skip-Interceptor', value: ''};
export const TOKEN_REFRESH_HEADER = {name: 'X-Token-Refresh', value: ''};
export const AUTHORISATION_BEARER_HEADER = {name: 'Authorization', value: 'Bearer '};
